import { createAction, props } from '@ngrx/store';

export const updateUWQuestionsIsLoadingFromUWQuestionsSavingData = createAction(
  '[UWQuestionsSavingData] Update UWQuestions Is Loading',
  props<{ isLoading: boolean }>()
);